const intSort = (a, b) => a - b;

export const sum = (arr) => arr.reduce((a, b) => a + b, 0);

export const average = (arr) => sum(arr) / arr.length;

export const round = (num, decimals = 0) => {
  const factor = 10 ** decimals;
  return Math.round(num * factor) / factor;
};

export const median = (list) => {
  const sorted = (list || []).sort(intSort);
  const middle = Math.floor(sorted.length / 2);
  const isOdd = sorted.length % 2 !== 0;
  if (isOdd) return sorted[middle] || null;
  return average(sorted.slice(middle - 1, middle + 1));
};
